import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Button} from '@components/common/button/button'
import {LinkAsButton} from '@components/sticker/my-stickers/common/add-link/add-link'
import {useTaskDescription} from '../task-description-store'

export const TopPanelButtons = observer(() => {
  const [, store] = useTaskDescription()

  const onSave = () => {
    void store.saveContent()
  }

  return (
    <>
      <Button onClick={onSave}>{Lang.msg.save}</Button>
      <LinkAsButton onClick={store.cancelEdit}>{Lang.msg.cancel}</LinkAsButton>
    </>
  )
})
